module.exports = __webpack_public_path__ + "static/media/bar-horiz-stacked-icon.d27c6b4d.svg";